module.exports = __webpack_public_path__ + "img/LOGO.b3063783.png";